"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelfEvent = exports.SearchMode = exports.RecordSubject = void 0;
let SelfEvent = exports.SelfEvent = /*#__PURE__*/function (SelfEvent) {
  SelfEvent["SelfBirth"] = "SelfBirth";
  SelfEvent["SelfDeath"] = "SelfDeath";
  SelfEvent["SelfMarriage"] = "SelfMarriage";
  SelfEvent["SelfResidence"] = "SelfResidence";
  SelfEvent["SelfArrival"] = "SelfArrival";
  SelfEvent["SelfDeparture"] = "SelfDeparture";
  SelfEvent["SelfMilitary"] = "SelfMilitary";
  return SelfEvent;
}({});
let RecordSubject = exports.RecordSubject = /*#__PURE__*/function (RecordSubject) {
  RecordSubject["All"] = "all";
  RecordSubject["Primary"] = "primary";
  RecordSubject["Secondary"] = "secondary";
  return RecordSubject;
}({});
let SearchMode = exports.SearchMode = /*#__PURE__*/function (SearchMode) {
  SearchMode["Simple"] = "simple";
  SearchMode["Advanced"] = "advanced";
  return SearchMode;
}({});